// Centralized form-field validators.
// Reuse across every registration / profile / contact form.

// ── Email ────────────────────────────────────────────────────────────────────
// RFC-like practical check: no spaces, has local + @ + host.tld
export const isValidEmail = (v) => {
  if (!v) return false;
  const s = String(v).trim();
  // max 254 total, max 64 before @
  if (s.length > 254) return false;
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s)) return false;
  const [local, host] = s.split('@');
  if (local.length > 64) return false;
  if (!/^[a-zA-Z]{2,}$/.test(host.split('.').pop())) return false;
  return true;
};

// ── URL / Website ────────────────────────────────────────────────────────────
// Accepts "example.com", "www.foo.co.uk", "https://x.io/path".
export const isValidUrl = (v) => {
  if (!v) return false;
  const raw = String(v).trim();
  if (raw.length < 4 || raw.length > 2048) return false;
  const candidate = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
  try {
    const u = new URL(candidate);
    // must have a dotted host with a proper TLD (≥2 alpha chars)
    if (!/\.[a-zA-Z]{2,}$/.test(u.hostname)) return false;
    if (u.hostname.includes(' ')) return false;
    return true;
  } catch { return false; }
};

// Prepend https:// if the user typed a bare domain (for server-side storage).
export const normalizeUrl = (v) => {
  if (!v) return '';
  const raw = String(v).trim();
  if (!raw) return '';
  return /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
};

// ── Phone (digits-only, country-code aware) ──────────────────────────────────
// Input: the *national* part already stripped of the + and dial code.
export const isValidPhoneDigits = (digits, { min = 7, max = 15 } = {}) => {
  if (!digits) return false;
  const s = String(digits).replace(/\D+/g, '');
  return s.length >= min && s.length <= max;
};

// Given a full E.164 string "+905551234567", return true if total digits are
// between 7 and 15 (ITU-T E.164 upper bound).
export const isValidE164 = (v) => {
  if (!v) return false;
  const s = String(v).trim();
  if (!/^\+?[0-9]{7,15}$/.test(s.replace(/\s+/g, ''))) return false;
  return true;
};
